import { render, staticRenderFns } from "./VContainer.vue?vue&type=template&id=5abea04e&scoped=true"
import script from "./VContainer.vue?vue&type=script&lang=js"
export * from "./VContainer.vue?vue&type=script&lang=js"
import style0 from "./VContainer.vue?vue&type=style&index=0&id=5abea04e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abea04e",
  null
  
)

export default component.exports